import axios from "axios";

let url = "";
let stag_url = "";
let IS_RETAILER = "";
let APP_LANGUAGE= "";
url = import.meta.env.VITE_APP_API || "";
stag_url = import.meta.env.VITE_APP_ASSETS_URL || "";
IS_RETAILER = import.meta.env.VITE_APP_IS_RETAILER || "";
APP_LANGUAGE = import.meta.env.VITE_APP_LANGUAGE || "";
export const path = () => {
  return stag_url;
};

export default axios.create({
  baseURL: url,
});
export const apiPath = () => {
  return url;
};
export { IS_RETAILER ,APP_LANGUAGE};
